import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=50e6ff7a&scoped=true&"
import script from "./PartnerInfo.vue?vue&type=script&lang=ts&"
export * from "./PartnerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerInfo.vue?vue&type=style&index=0&id=50e6ff7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6ff7a",
  null
  
)

export default component.exports